// userFormConfig.js

import {
  cilCalendar,
  cilEnvelopeClosed,
  cilFlagAlt,
  cilGraph,
  cilInfo,
  cilScreenSmartphone,
  cilUser,
} from '@coreui/icons';
import { CFormCheck } from '@coreui/react';
import dayjs from 'dayjs';
import moment from 'moment';
import CustomInput from 'src/components/InputsComponent/CustomInput';
import CustomSelectInput from 'src/components/InputsComponent/CustomSelectInput';
import CustomDatePicker from 'src/components/UI/DatePicker';
import globalutil from 'src/util/globalutil';

export const OFFERING_TYPE = [
  {
    id: 1,
    name: 'Full Time',
  },
  {
    id: 2,
    name: 'Part Time',
  },
  {
    id: 3,
    name: 'Seasonal',
  },
];

export const SUFFIX = [
  {
    id: 1,
    name: 'Mr.',
  },
  {
    id: 2,
    name: 'Mrs.',
  },
  {
    id: 3,
    name: 'Ms.',
  },
  {
    id: 4,
    name: 'He',
  },
  {
    id: 5,
    name: 'Him',
  },
  {
    id: 6,
    name: 'She',
  },
  {
    id: 7,
    name: 'Her',
  },
  {
    id: 8,
    name: 'They',
  },
  {
    id: 9,
    name: 'Them',
  },
  {
    id: 10,
    name: 'Jr.',
  },
  {
    id: 11,
    name: 'Sr.',
  },
  {
    id: 12,
    name: 'I',
  },
  {
    id: 13,
    name: 'II',
  },
  {
    id: 14,
    name: 'III',
  },
  {
    id: 15,
    name: 'IV',
  },
  {
    id: 16,
    name: 'V',
  },
];
export const getDaAppllyInputs = (
  daUserData,
  handleUserInput,
  handleFocus,
  emailReadonly,
  emailMessage,
  onBlur,
  dspsListRes,
  dsp,
) => [
  {
    component: CustomInput,
    label: 'First Name',
    value: daUserData.firstName,
    onChange: handleUserInput,
    icon: cilUser,
    type: 'text',
    id: 'FirstName',
    name: 'firstName',
    placeholder: 'First Name',
    className: 'form-control item',
    isRequired: true,
    maxLength: 10,
    autoFocus: true,
    message: 'Enter First Name',
  },

  {
    component: CustomInput,
    label: 'Last Name',
    value: daUserData.lastName,
    onChange: handleUserInput,
    icon: cilUser,
    type: 'text',
    id: 'lastName',
    name: 'lastName',
    placeholder: 'Last Name',
    className: 'form-control item',
    isRequired: true,
    maxLength: 10,
    message: 'Enter Last Name',
  },
  {
    component: CustomInput,
    label: 'Email Address ',
    labelNote: 'Brand new email is required',
    value: daUserData.email,
    onChange: handleUserInput,
    icon: cilEnvelopeClosed,
    type: 'email',
    id: 'email',
    name: 'email',
    placeholder: 'Email Address',
    className: 'form-control item',
    isRequired: true,
    onBlur: onBlur,
    message: emailMessage,
  },

  {
    component: CustomInput,
    label: 'Contact',
    value: daUserData.primaryContact,
    onChange: handleUserInput,
    icon: cilScreenSmartphone,
    type: 'text',
    id: 'primaryContact',
    name: 'primaryContact',
    placeholder: 'Enter Contact',
    className: 'form-control item',
    isRequired: true,
    maxLength: 10,
    pattern: '\\d{10}',
    message: 'Enter valid contact number Format: 1234567890',
  },
  {
    component: CFormCheck,
    name: 'isWhatsAppAsso',
    checked: daUserData.isWhatsAppAsso,
    onChange: handleUserInput,
    className: 'mt-5 mblView',
    id: 'isWhatsAppAsso',
    label: 'Is this whatsapp associated?',
  },
  {
    component: CustomSelectInput,
    label: 'Suffix',
    icon: cilFlagAlt,
    id: 'suffix',
    className: 'form-control item form-select',
    value: daUserData.suffix,
    options: globalutil?.suffixes(),
    name: 'suffix',
    placeholder: 'Enter Suffix',
    type: 'text',
    onChange: (e) => handleUserInput(e),
    isRequired: true,
    title: 'Suffix',
    message: 'suffix',
  },
  {
    component: CustomSelectInput,
    label: 'Offering Type',
    icon: cilInfo,
    id: 'offerType',
    options: OFFERING_TYPE,
    className: 'form-control item form-select',
    value: daUserData.offerType,
    name: 'offerType',
    onChange: (e) => handleUserInput(e),
    isRequired: true,
    disableOption: 'Select Offering Type',
    message: 'Please Select Offering Type',
  },
  {
    component: CustomSelectInput,
    label: 'Position(s)',
    icon: cilGraph,
    id: 'positionType',
    options: globalutil?.userroles()?.filter((role) => role?.id === 3 || role?.id === 8) ?? [],
    className: 'form-control item form-select',
    value: daUserData.positionType,
    name: 'positionType',
    onChange: (e) => {
      const selectedValue = Number(e.target.value);
      const userDob = moment(daUserData.dob); // Ensure dob is a Moment object
      const userAge = moment().diff(userDob, 'years'); // Calculate age properly
      if (selectedValue === 3 && userAge < 21) {
        handleUserInput(moment().subtract(21, 'years').format('YYYY-MM-DD'), 'dob');
      }

      if (selectedValue === 8 && userAge < 18) {
        handleUserInput(moment().subtract(18, 'years').format('YYYY-MM-DD'), 'dob');
      }

      handleUserInput(e);
    },
    isRequired: true,
    disableOption: 'Select Position Type',
    message: 'Please Select Offering Type',
    showDisabled: true,
  },
  {
    component: CustomSelectInput,
    label: 'DSP',
    icon: cilInfo,
    id: 'dspid',
    options: dspsListRes,
    className: 'form-control item form-select',
    value: daUserData.dspid,
    name: 'dspid',
    onChange: (e) => {
      handleUserInput(e);
    },
    isRequired: true,
    disableOption: 'Select DSP',
    message: 'Please select user dsp',
    disabled: dsp ? true : false,
  },
  {
    component: CustomDatePicker,
    icon: cilCalendar,
    label: `Date of Birth`,
    value: daUserData.dob,
    onChange: (e) => handleUserInput(e, 'dob'),
    isRequired: true,
    noDefault: true,
    max: dayjs().subtract(daUserData.positionType == 3 ? 21 : 18, 'years'),
    title: 'enter date of birth',
    message: 'DA age should be 21 or above',
  },
];

export const getInitialDaData = () => ({
  id: 0,
  firstName: '',
  lastName: '',
  dspid: '',
  offerType: '',
  primaryContact: '',
  positionType: 3,
  email: '',
  userId: '',
  licenseIssueDate: null,
  licenseExpiryDate: null,
  dob: null,
  isWhatsAppAsso: false,
  status: 5,
  isTermsAccepted: false,
  suffix: globalutil?.suffixes()?.[0]?.id || '',
  createdAt: moment().utc().format(),
  lastUpdatedAt: moment().utc().format(),
  createdBy: 1,
  lastUpdatedBy: 1,
});
